module.exports = __webpack_public_path__ + "img/home-ad-btn.29278b26.png";